export default function Services() {
  return (
    <section className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-5xl font-semibold text-[#002B5C] text-center mb-20">
          Comprehensive Scientific Services
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="relative rounded-2xl overflow-hidden aspect-square group cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/e6355265ad452965835417c1de628e7a.jpg"
              alt="Clean Room Manufacturing"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#002B5C]/40 group-hover:bg-[#002B5C]/50 transition-colors"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
              <h3 className="text-3xl font-bold text-white mb-4">
                Clean Room Manufacturing
              </h3>
              <p className="text-sm text-white/90 leading-relaxed">
                State-of-the-art facilities meeting ISO standards for medical device and pharmaceutical production
              </p>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden aspect-square group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=high%20performance%20liquid%20chromatography%20HPLC%20analysis%20equipment%20in%20modern%20analytical%20laboratory%20scientist%20analyzing%20chemical%20compounds%20colorful%20chromatogram%20results%20pharmaceutical%20quality%20testing%20simple%20clean%20background&width=600&height=600&seq=chromatography-analysis&orientation=squarish"
              alt="Chromatography Analysis"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#002B5C]/40 group-hover:bg-[#002B5C]/50 transition-colors"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
              <h3 className="text-3xl font-bold text-white mb-4">
                Advanced Analytics
              </h3>
              <p className="text-sm text-white/90 leading-relaxed">
                Comprehensive testing and analysis using cutting-edge chromatography and spectroscopy techniques
              </p>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden aspect-square group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=scientific%20research%20documentation%20laboratory%20notebook%20with%20detailed%20experimental%20data%20graphs%20charts%20scientist%20hands%20writing%20research%20findings%20peer%20review%20validation%20process%20simple%20clean%20background&width=600&height=600&seq=research-documentation&orientation=squarish"
              alt="Research Documentation"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#002B5C]/40 group-hover:bg-[#002B5C]/50 transition-colors"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
              <h3 className="text-3xl font-bold text-white mb-4">
                Research Validation
              </h3>
              <p className="text-sm text-white/90 leading-relaxed">
                Expert peer review and validation services ensuring research integrity and reproducibility
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}